import classNames from 'classnames';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export const SectionTitle: FC<{ className?: string; textKey: IntlKey }> = ({ className, textKey }) => {
  const { formatMessage } = useIntl();
  return <h5 className={classNames('ms-3', className)}>{formatMessage({ id: textKey })}</h5>;
};

export const SectionSubTitle: FC<{ className?: string; textKey: IntlKey }> = ({ className, textKey }) => {
  const { formatMessage } = useIntl();
  return <h6 className={classNames('my-3 text-secondary', className)}>{formatMessage({ id: textKey })}</h6>;
};
